import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import { GRID_VALUES } from "%/dynamic-component-editor/options/object-position";

export default class BackgroundPosition extends BaseOption {
  static userInterfaceComponent = {
    label: "Background Position",
    component: inspectorTools.RADIO_BAR,
    props: {
      options: GRID_VALUES,
      defaultIcon: "dot",
    },
  };

  static defaultValue = "center";

  static convertConfigValueToCompiledValue(configValue) {
    if (GRID_VALUES.map(item => item.value).includes(configValue)) {
      return configValue;
    }
    return "center";
  }
}
